// extracted by css-extract-rspack-plugin
export default {"separator":"N5nLwdxwdeYZmkrn"};